import { Spinner } from '@ibsys/kit';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAiAgentChats } from '@/entities/ai-agent-chat';
import { useCopilot } from '@/features/copilot';
import { CopilotChatCard } from './CopilotChatCard';

export const CopilotChatListView: FC = () => {
  const { t } = useTranslation(['aiAgent']);
  const { openChat } = useCopilot();
  const { data, isLoading } = useAiAgentChats({ limit: 50, offset: 0 });

  const handleChatClick = useCallback(
    (chatId: number) => {
      openChat(chatId);
    },
    [openChat],
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center flex-1">
        <Spinner className="size-8" />
      </div>
    );
  }

  if (!data?.items.length) {
    return (
      <div className="flex items-center justify-center  flex-1">
        <p className="text-muted-foreground">{t('aiAgent:emptyChatList')}</p>
      </div>
    );
  }

  return (
    <div className="flex  flex-1 flex-col gap-2 p-2">
      {data.items.map((chat) => (
        <CopilotChatCard key={chat.id} chat={chat} onClick={handleChatClick} />
      ))}
    </div>
  );
};
